"use strict";
/**
 * Organization API helper functions
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.organizationApi = void 0;
const apiClient_1 = require("./apiClient");
const validation_1 = require("./validation");
const apiMappers_1 = require("./apiMappers");
/**
 * Organization API endpoints
 */
exports.organizationApi = {
    /**
     * Get all organizations
     * @returns Promise resolving to array of organizations sorted alphabetically
     */
    getOrganizations: () => {
        return apiClient_1.apiClient
            .get('/organization')
            .then(data => data
            .map(apiMappers_1.mapOrganization)
            .sort((a, b) => a.name.localeCompare(b.name)));
    },
    /**
     * Get organization by ID
     * @param id - Organization ID
     * @returns Promise resolving to organization
     */
    getOrganizationById: (id) => {
        (0, validation_1.validateId)(id, 'Organization ID');
        return apiClient_1.apiClient.get(`/organization/${id}`).then(apiMappers_1.mapOrganization);
    },
    /**
     * Get organizations by tenant ID
     * @param tenantId - Tenant ID
     * @returns Promise resolving to array of organizations sorted alphabetically
     */
    getOrganizationsByTenant: (tenantId) => {
        (0, validation_1.validateId)(tenantId, 'Tenant ID');
        return apiClient_1.apiClient
            .get(`/organization/tenant/${tenantId}`)
            .then(data => data
            .map(apiMappers_1.mapOrganization)
            .sort((a, b) => a.name.localeCompare(b.name)));
    },
};
